"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMeterReads = void 0;
var mapKapiToDisplay_1 = require("../../../../domains/kapi-meter-reads/data/mapping/mapKapiToDisplay");
var kapi_1 = require("../../kapi");
var useMeterReads = function (accountId, skip) {
    if (skip === void 0) { skip = false; }
    var variables = {
        accountId: accountId,
    };
    var _a = (0, kapi_1.useApMeterReadsQuery)({
        variables: variables,
        skip: skip,
    }), data = _a.data, loading = _a.loading, error = _a.error;
    var mappedData = data ? (0, mapKapiToDisplay_1.mapKapiToDisplay)(data) : undefined;
    return {
        loading: loading,
        error: error,
        data: mappedData,
    };
};
exports.useMeterReads = useMeterReads;
